import { ProductConfig } from '../components/canje/ProductConfig';
import { TipoProducto } from '../model/ProductoData';

/** Nombre comercial del programa de premios */
export const NOMBRE_APLICACION = 'mesumo';

/**Nombre comercial del homebanking(BIP)*/
export const NOMBRE_HOMEBANKING = 'Home Banking BIP';

export const LEGALES_TEXTO: string = `Para canjear en el nuevo catálogo validá por única vez tu mail en <b>${NOMBRE_HOMEBANKING}</b>`;
export const LEGALES_LINK: any | undefined = {
  ruta: 'https://www.bancoprovincia.com.ar/CDN/Get/Programa_mesumo',
  abreSolapa: false,
  isExterno: false,
  tag: 'mesumo_instructivo',
};

/** Barra con notificación debajo del banner */
export const NOVELTIES_BARRA_INICIO = '2025-01-23T00:00:00';
export const NOVELTIES_BARRA_FIN = '3025-10-31T00:00:00';
export const NOVELTIES_BARRA_MENSAJE1 = 'Novedades sobre tus puntos.';
export const NOVELTIES_BARRA_MENSAJE2 = '';
export const NOVELTIES_BARRA_ENLACE = {
  enlace: {
    ruta: 'https://www.bancoprovincia.com.ar/web/mesumo_puntos_2',
    abreSolapa: false,
    isExterno: false,
    tag: '',
  },
};

/** Login */
export const LOGIN_DEFAULT_ERROR_MESSAGE = 'Por favor intente más tarde.';
export const LOGIN_TITLE = 'Ingreso';
export const OTP_LENGTH = 6;
/** Enlaces adicionales en ventana de login */
export const LOGIN_REGISTER_TITLE = 'Cómo me adhiero al Programa';
export const LOGIN_REGISTER_LINK = LEGALES_LINK;

/** Canje */
export enum PROVINCE {
  CIUDAD_BUENOS_AIRES = 1,
  PROVINCIA_DE_BUENOS_AIRES = 2,
}
export const PROVINCIAS_OPCIONES = [
  { title: 'Ciudad de Buenos Aires', value: PROVINCE.CIUDAD_BUENOS_AIRES },
  { title: 'Provincia de Buenos Aires', value: PROVINCE.PROVINCIA_DE_BUENOS_AIRES },
];

export const CANJE_MODAL_TITULO = 'Seguí los pasos para completar tu canje';
export const CANJE_MODAL_RESUMEN_PRODUCTO_PART1 = 'Vas a realizar un canje de';
export const CANJE_DEFAULT_ERROR_MESSAGE = 'No se pudo realizar el canje. Por favor, intentá más tarde.';
export const CANJE_EXITOSO_MENSAJE = 'Canje realizado con éxito. ¡Que disfrutes tu premio!';

export const CANJE_PRODUCTO_CONFIGS = new Map<TipoProducto, ProductConfig>([
  [
    TipoProducto.FISICO,
    {
      tituloModal: CANJE_MODAL_TITULO,
      productoResumenParte1: 'Estás canjeando',
      productoResumenParte2: 'un/una',
      exitoTitulo: CANJE_EXITOSO_MENSAJE,
      exitoSubtitulo: 'Recibirás un mail para el seguimiento de la entrega del producto.',
      incluyeStock: true,
    },
  ],
  [
    TipoProducto.VOUCHER,
    {
      tituloModal: CANJE_MODAL_TITULO,
      productoResumenParte1: CANJE_MODAL_RESUMEN_PRODUCTO_PART1,
      productoResumenParte2: 'un',
      exitoTitulo: CANJE_EXITOSO_MENSAJE,
      exitoSubtitulo: 'Consultá cómo hacer uso del voucher en la descripción del premio elegido.',
      incluyeStock: true,
    },
  ],
  [
    TipoProducto.SOLIDARIDAD,
    {
      tituloModal: CANJE_MODAL_TITULO,
      productoResumenParte1: CANJE_MODAL_RESUMEN_PRODUCTO_PART1,
      productoResumenParte2: 'una',
      exitoTitulo: 'Canje realizado con éxito. ¡Gracias por colaborar!',
      exitoSubtitulo: 'Recibirás un mail con el comprobante de tu donación.',
      incluyeStock: false,
    },
  ],
  [
    TipoProducto.SMILES,
    {
      tituloModal: CANJE_MODAL_TITULO,
      productoResumenParte1: CANJE_MODAL_RESUMEN_PRODUCTO_PART1,
      productoResumenParte2: '',
      exitoTitulo: CANJE_EXITOSO_MENSAJE,
      exitoSubtitulo: 'Recibirás un mail con los datos del canje realizado.',
      incluyeStock: true,
    },
  ],
  [
    TipoProducto.CDNI,
    {
      tituloModal: CANJE_MODAL_TITULO,
      productoResumenParte1: CANJE_MODAL_RESUMEN_PRODUCTO_PART1,
      productoResumenParte2: 'un',
      exitoTitulo: CANJE_EXITOSO_MENSAJE,
      exitoSubtitulo: 'El descuento se aplicará en las compras que realices durante la segunda quincena de este mes.',
      incluyeStock: true,
    },
  ],
  [
    TipoProducto.CHANCE,
    {
      tituloModal: CANJE_MODAL_TITULO,
      productoResumenParte1: CANJE_MODAL_RESUMEN_PRODUCTO_PART1,
      productoResumenParte2: '',
      exitoTitulo: 'Canje realizado con éxito.',
      exitoSubtitulo: 'Seguí sumando chances hasta el 30/04/26.',
      incluyeStock: true,
    },
  ],
]);

/** Sesión de usuario */
export const SESSION_KEY = 'userdata';

/**Catálogo*/
export const FILTROS_PUNTOS_LIMITE = [5000, 10000, 20000, 30000, 50000];

/** Footer */
export const FOOTER_DATA = {
  ICONOS_GRANDES: [
    {
      orden: 2,
      titulo: 'Contactanos',
      rutaImagen: '/cdn/icono_consultanos',
      icono:
        "<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' id='Capa_1' x='0px' y='0px' viewBox='0 0 26.2 26.2' style='enable-background:new 0 0 26.2 26.2;' xml:space='preserve'><g><g><path d='M18.1,26.1H8.3c-1.7,0-3.2-1.4-3.2-3.2V3.2c0-1.7,1.4-3.2,3.2-3.2h9.8c1.7,0,3.2,1.4,3.2,3.2V23    C21.3,24.7,19.9,26.1,18.1,26.1z M8.3,1.5c-1,0-1.8,0.8-1.8,1.8V23c0,1,0.8,1.8,1.8,1.8h9.8c1,0,1.8-0.8,1.8-1.8V3.2    c0-1-0.8-1.8-1.8-1.8H8.3z'/></g><rect x='8.2' y='20.2' width='9.9' height='1.4'/><path d='M14.2,5.6h-2.1c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h2.1c0.4,0,0.7,0.3,0.7,0.7S14.6,5.6,14.2,5.6z'/></g></svg>",
      enlace: {
        ruta: 'https://www.bancoprovincia.com.ar/web/informacion_de_utilidad',
        abreSolapa: false,
        isExterno: false,
      },
    },
  ],
  BCRA: {
    imageUrl: '/gateway/cdn/btn_ufi',
    enlace: {
      ruta: 'http://www.bcra.gob.ar/BCRAyVos/Usuarios_Financieros.asp',
      abreSolapa: true,
      isExterno: true,
      tag: '',
    },
    textoAlternativo: 'Sello BCRA',
  },
  adhesion: {
    imageUrl: '/gateway/cdn/sello_mesumo',
    enlace: {
      ruta: 'https://www.bancoprovincia.com.ar/CDN/Get/bases_y_condiciones_mesumo',
      abreSolapa: false,
      isExterno: false,
      tag: '',
    },
    textoAlternativo: 'Bases y condiciones',
  },
  arrepentimiento: {
    imageUrl: '/gateway/cdn/btn_arrepentimiento',
    enlace: {
      ruta: 'https://www.bancoprovincia.com.ar/web/arrepentimiento',
      abreSolapa: false,
      isExterno: false,
      tag: '',
    },
    textoAlternativo: 'Botón de arrepentimiento',
  },
  tycs: {
    titulo: 'Términos y condiciones de navegabilidad de sitio web',
    enlace: {
      ruta: ' https://www.bancoprovincia.com.ar/CDN/Get/Terminos_y_condiciones_Banco_Provincia',
      abreSolapa: true,
      isExterno: false,
      tag: '',
    },
  },
  copyright: `© ${new Date().getFullYear()} - Banco de la Provincia de Buenos Aires - Casa Matriz: Calle 7 N° 726 (B1900TFS) La Plata, Buenos Aires, Argentina.`,
  redes: [
    {
      icono:
        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26.23 26.23'>    <path d='M13.76,4.81h2.79c0,1,0,2,0,2.87-.82.09-1.72-.18-2.23.16S14.1,9.37,14,10.25h2.57c-.09,1-.21,1.9-.29,2.87H14v8.3H10.87v-8.3c-.68,0-1.43,0-2.07,0,0-.94,0-1.94,0-2.84h2c0-1.66-.12-3.23.51-4.24A3,3,0,0,1,13.76,4.81Z' />    <path d='M13.12,26.23A13.12,13.12,0,1,1,26.23,13.12,13.13,13.13,0,0,1,13.12,26.23Zm0-24.83A11.72,11.72,0,1,0,24.83,13.12,11.74,11.74,0,0,0,13.12,1.4Z' /></svg>",
      titulo: 'Facebook',
      orden: 1,
      id: 0,
      enlace: {
        ruta: 'https://www.facebook.com/bancoprovincia?fref=ts',
        abreSolapa: true,
        isExterno: true,
      },
    },
    {
      icono:
        '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26.2 26.2" style="enable-background:new 0 0 26.2 26.2;" xml:space="preserve"><path d="M13.1,26.2C5.9,26.2,0,20.4,0,13.1S5.9,0,13.1,0s13.1,5.9,13.1,13.1c0,0,0,0,0,0C26.2,20.4,20.4,26.2,13.1,26.2z M13.1,1.4 C6.6,1.4,1.4,6.6,1.4,13.1c0,6.5,5.2,11.7,11.7,11.7c6.5,0,11.7-5.2,11.7-11.7c0,0,0,0,0,0C24.8,6.7,19.6,1.4,13.1,1.4z"/><path d="M14.4,12l5.1-5.9h-1.2l-4.4,5.1l-3.5-5.1H6.3l5.3,7.7l-5.3,6.2h1.2l4.7-5.4l3.7,5.4h4.1L14.4,12L14.4,12z M12.8,14l-0.5-0.8 L7.9,7.2h1.8l3.5,4.9l0.5,0.8l4.5,6.4h-1.8L12.8,14L12.8,14z"/></svg>',
      titulo: 'Twitter',
      orden: 2,
      id: 0,
      enlace: {
        ruta: 'https://x.com/bancoprovincia',
        abreSolapa: true,
        isExterno: true,
      },
    },
    {
      icono:
        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26.23 26.23' ><path d='M13.12,26.23A13.12,13.12,0,1,1,26.23,13.12,13.13,13.13,0,0,1,13.12,26.23Zm0-24.83A11.72,11.72,0,1,0,24.83,13.12,11.74,11.74,0,0,0,13.12,1.4Z' /><path d='M13.12,7.32c1.88,0,2.11,0,2.85,0a3.81,3.81,0,0,1,1.32.25,2.08,2.08,0,0,1,.81.53,2.11,2.11,0,0,1,.53.81,4.06,4.06,0,0,1,.24,1.31c0,.75,0,1,0,2.86s0,2.11,0,2.85a4.14,4.14,0,0,1-.24,1.32,2.37,2.37,0,0,1-1.34,1.34,4.14,4.14,0,0,1-1.32.24c-.74,0-1,0-2.85,0s-2.11,0-2.86,0A4.06,4.06,0,0,1,9,18.63a2.11,2.11,0,0,1-.81-.53,2.08,2.08,0,0,1-.53-.81A3.81,3.81,0,0,1,7.36,16c0-.74,0-1,0-2.85s0-2.11,0-2.86A3.73,3.73,0,0,1,7.61,9a2,2,0,0,1,.53-.81A2,2,0,0,1,9,7.61a3.73,3.73,0,0,1,1.31-.25c.75,0,1,0,2.86,0m0-1.27c-1.92,0-2.16,0-2.92,0a4.93,4.93,0,0,0-1.71.33A3.53,3.53,0,0,0,6.42,8.49a4.93,4.93,0,0,0-.33,1.71c0,.76,0,1,0,2.92s0,2.16,0,2.91a5,5,0,0,0,.33,1.72A3.49,3.49,0,0,0,7.23,19a3.7,3.7,0,0,0,1.26.82,5.2,5.2,0,0,0,1.71.32c.76,0,1,.05,2.92.05s2.16,0,2.91-.05a5.27,5.27,0,0,0,1.72-.32,3.68,3.68,0,0,0,2.07-2.07A5.27,5.27,0,0,0,20.14,16c0-.75.05-1,.05-2.91s0-2.16-.05-2.92a5.2,5.2,0,0,0-.32-1.71A3.7,3.7,0,0,0,19,7.23a3.49,3.49,0,0,0-1.25-.81A5,5,0,0,0,16,6.09c-.75,0-1,0-2.91,0Z' /><path d='M13.12,9.49a3.63,3.63,0,1,0,3.63,3.63A3.62,3.62,0,0,0,13.12,9.49Zm0,6a2.36,2.36,0,1,1,2.35-2.35A2.36,2.36,0,0,1,13.12,15.47Z' /><path d='M17.74,9.34a.85.85,0,1,1-.85-.84A.85.85,0,0,1,17.74,9.34Z' /></svg>",
      titulo: 'Instagram',
      orden: 3,
      id: 0,
      enlace: {
        ruta: 'https://www.instagram.com/banco_provincia/?igshid=1a9slp6g7wfud',
        abreSolapa: true,
        isExterno: true,
      },
    },
    {
      icono:
        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26.23 26.23' ><path d='M21.08,14.08V12.3c0-2-.26-3.77-1.54-4.55-.68-.42-2.32-.35-3.43-.4-2.7-.12-5.32,0-8,.08a4.9,4.9,0,0,0-1.89.26c-1.3.75-1.54,2.63-1.57,4.56V14c0,2,.26,4,1.81,4.61a6.47,6.47,0,0,0,1.7.21,82.71,82.71,0,0,0,9.58,0,8.45,8.45,0,0,0,1.52-.13C21,18.21,21,16.05,21.08,14.08ZM10.84,10.23c1.72.94,3.37,1.95,5.08,2.88a7,7,0,0,1-1.23.76c-1.27.73-2.58,1.51-3.85,2.2Z' /><path d='M13.12,26.23A13.12,13.12,0,1,1,26.23,13.12,13.13,13.13,0,0,1,13.12,26.23Zm0-24.83A11.72,11.72,0,1,0,24.83,13.12,11.74,11.74,0,0,0,13.12,1.4Z' /></svg>",
      titulo: 'YouTube',
      orden: 4,
      id: 0,
      enlace: {
        ruta: 'https://www.youtube.com/channel/UCh6D5Dvp9ua7UqVMGOhIsog',
        abreSolapa: true,
        isExterno: true,
      },
    },
    {
      icono:
        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26.23 26.23' ><path d='M13.12,26.23A13.12,13.12,0,1,1,26.23,13.12,13.13,13.13,0,0,1,13.12,26.23Zm0-24.83A11.72,11.72,0,1,0,24.83,13.12,11.74,11.74,0,0,0,13.12,1.4Z' /><path d='M19.37,13.49v4.32H16.86v-4c0-1-.36-1.71-1.27-1.71a1.37,1.37,0,0,0-1.28.92,1.6,1.6,0,0,0-.09.61v4.21h-2.5s0-6.83,0-7.54h2.5v1.1h0v0a2.5,2.5,0,0,1,2.26-1.24c1.65,0,2.89,1.07,2.89,3.39ZM7.83,17.81h2.5V10.27H7.83Zm0,0M10.41,7.72A1.29,1.29,0,1,1,9.12,6.43,1.29,1.29,0,0,1,10.41,7.72Z' /></svg>",
      titulo: 'LinkedIn',
      orden: 5,
      id: 0,
      enlace: {
        ruta: 'https://www.linkedin.com/company/banco-de-la-provincia-de-buenos-aires',
        abreSolapa: true,
        isExterno: true,
      },
    },
  ],
};

/**Cliente en estado de mora */
export const MORA_TITULO_MODAL = 'Aviso';
export const MORA_PHONE = '0800-222-6672';
export const MORA_PHONE_URL = `tel:${MORA_PHONE}`;
export const MORA_PHONE_TITLE = `Teléfono ${MORA_PHONE}`;
export const MORA_INFO_1 =
  'Detectamos una deuda pendiente. Una vez regularizada, podrás seguir sumando puntos y canjeando premios en el programa.';
export const MORA_INFO_2_MOBILE = '¿Tenés dudas? Llamanos al:';
export const MORA_INFO_2_DESKTOP = `¿Tenés dudas? <br/> Llamanos al ${MORA_PHONE}`;
